<template>
  <div class="flight-stops ml-4">
    <template v-if="primary">
      <div
        v-if="stops === 1"
        class="flight-stops__title"
      >
        <span data-i18n="charterDirectFlight">
          {{ $t('charterDirectFlight') }}
        </span>
        <span v-if="duration">
          &nbsp;&middot; {{ formattedDuration }}
        </span>
      </div>
      <template v-else-if="stops > 1">
        <LazyToggleFlightLegsButton
          :expanded="expanded"
          :flights-collapsed="flightsCollapsed"
          :stops="stops"
          :duration="duration"
          @expand="$emit('expand')"
          @collapse="$emit('collapse')"
        />
        <span v-if="!expanded">
          <span
            v-for="item in stops - 1"
            :key="item"
            class="flight-stops__stop"
          />
        </span>
      </template>
    </template>
  </div>
</template>

<script>
export default defineNuxtComponent({
  name: 'FlightStops',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },

    stops: {
      type: Number,
      default: 0,
    },

    duration: {
      type: String,
      default: '',
    },

    expanded: {
      type: Boolean,
      default: false,
    },

    flightsCollapsed: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['collapse', 'expand'],

  computed: {
    formattedDuration () {
      if (!this.duration) {
        return
      }

      let format = ''

      const duration = this.$dayjs.duration(this.duration)

      if (duration.minutes() > 0) {
        format = 'm[m]'
      }
      if (duration.hours() > 0) {
        format = 'H[h] ' + format
      }
      if (duration.days() > 0) {
        format = 'D[d] ' + format
      }

      return duration.format(format)
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/charter/_flight-box";
</style>
